<template>
  <div>
    <b-popover target="popover-edit-scheduled-start-date" triggers="click" custom-class="scheduled-start-date-popover" :show.sync="popoverShow" placement="rightbottom" container="milestone-carousel-list" ref="reschedule-study-start-datepopover" @show="onShow" @shown="onShown" @hidden="onHidden">
      <Datepicker id="editScheduledStartDate" :inline="true" v-model="startDate" :highlighted="{ dates: [getLocalTimeOfParticipant(new Date())] }" :use-utc="true"></Datepicker>
      <div class="text-right mt-10">
        <b-button @click="onClose" :disabled="apiCallInProgress" class="btn-cancel" size="sm" variant="light">Cancel</b-button>
        <b-button @click="onOk" :disabled="disableChangeDateBtn || apiCallInProgress" class="btn-change-date" size="sm" variant="primary">Change Date</b-button>
      </div>
    </b-popover>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import _ from "lodash";
import * as DateTime from "../../services/date-time-functions";
export default {
  name: "editScheduledStartDate",
  data() {
    return {
      studyId: this.$route.params.studyId,
      popoverShow: false,
      startDate: this.scheduledStartDate,
      disableChangeDateBtn: true,
      apiCallInProgress: false,
      participantLocalDate: null
    };
  },
  props: {
    participantId: {
      type: String,
      required: true
    },
    piId: {
      type: String,
      required: true
    },
    scheduledStartDate: {
      required: true
    },
    participantDetails: {
      type: Object,
      default: null,
      required: false
    }
  },
  computed: {},
  watch: {
    scheduledStartDate(changedDate) {
      this.startDate = changedDate;
      this.disableChangeDateBtn = true;
    },
    startDate(newValue) {
      if (newValue && newValue.getTime() == this.scheduledStartDate.getTime()) {
        this.disableChangeDateBtn = true;
      } else {
        this.disableChangeDateBtn = false;
      }
      this.getLocalTimeOfParticipant();
    }
  },
  components: {
    Datepicker
  },
  methods: {
    onClose() {
      this.$swal({
        title: "Are you sure you want to cancel?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#4a4a4a",
        cancelButtonColor: "#1e8fe1",
        confirmButtonText: "Cancel",
        cancelButtonText: "Yes"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          this.popoverShow = false;
        }
      });
    },
    onOk() {
      this.$swal({
        title: "Are you sure you want to change the Study Start Date for this participant?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#4a4a4a",
        cancelButtonColor: "#1e8fe1",
        confirmButtonText: "Cancel",
        cancelButtonText: "Yes"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          this.scheduleStudyStart();
        }
      });
    },
    onShow() {
      // This is called just before the popover is shown
      this.startDate = this.scheduledStartDate;
      this.disableChangeDateBtn = true;
      this.$emit("rescheduleDatePopoverShown", true);
    },
    onShown() {
      // Called just after the popover has been shown
    },
    onHidden() {
      // Called just after the popover has finished hiding
      this.$emit("rescheduleDatePopoverShown", false);
    },
    scheduleStudyStart() {
      this.apiCallInProgress = true;
      let scheduleStartDateMoment = moment(this.startDate);
      let scheduledStartDate = scheduleStartDateMoment.format("DD MMM YYYY");
      const scheduleStartDateUTCDate = moment.utc(scheduledStartDate, "DD MMM YYYY");

      let toastMsg = "Study start will be requested as scheduled";
      if (scheduleStartDateMoment.isSame(moment(), "day")) {
        toastMsg = `Study start has been requested and is awaiting participant confirmation`;
      }

      const data = {
        participantId: this.participantId,
        studyId: this.studyId,
        triggeredBy: this.piId,
        scheduledStartDate: scheduleStartDateUTCDate.format("YYYY-MM-DD"),
        scheduledBy: this.piId,
        isReschedule: true,
        participantLocalDate: this.participantLocalDate
      };

      let siteMemberLocalOffset = moment().utcOffset();
      if (siteMemberLocalOffset < 0) {
        // For -ve timezones, the date offset is positive.
        siteMemberLocalOffset = -1 * siteMemberLocalOffset;
        const localDateObject = DateTime.getLocalDateTime(_.cloneDeep(this.startDate), siteMemberLocalOffset);
        data.scheduledStartDate = localDateObject.localDate;
        scheduledStartDate = localDateObject.basicLocalDate;
        scheduleStartDateMoment = localDateObject.localDateMoment;
      }

      this.$api.triggerParticipantDayZero(data).then(
        () => {
          this.$emit("studyStartScheduled", `Study start is scheduled for <span class="scheduled-date">${scheduledStartDate}</span>`, scheduleStartDateMoment);
          this.$toastr.success(toastMsg);
          this.popoverShow = false;
          this.apiCallInProgress = false;
        },
        error => {
          this.apiCallInProgress = false;
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Something went wrong while scheduling study start for participant");
        }
      );
    },
    getLocalTimeOfParticipant() {
      const participantStudyStartDate = DateTime.getLocalDateTime(new Date(), this.participantDetails.participantLocalOffset);
      this.participantLocalDate = participantStudyStartDate.localDate;
      return new Date(participantStudyStartDate.fullLocalDateTime);
    }
  }
};
</script>

<style scoped lang="scss" src="../../../public/static/fonts.scss"></style>
<style lang="scss">
.popover {
  width: auto !important;

  &.bs-popover-right {
    width: auto !important;

    button {
      font-size: 12px;
      font-family: Roboto-Regular;

      &.btn-cancel {
        color: #979797;
        margin-right: 5px;
        background: #fff;
      }

      &.btn-change-date {
        background-color: #4c8ce4;
        border-color: #4c8ce4;
        padding: 2px 6px;
        border-radius: 4px;

        &:hover {
          background-color: #34537d;
          border-color: #34537d;
        }
      }
    }
  }

  .vdp-datepicker {
    .vdp-datepicker__calendar {
      border: 0 !important;
    }
  }
}
</style>
